import styled from 'styled-components';
import { themes } from "../../theme/theme";

const AnimationBlock = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  margin: auto;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1500;
  transition: opacity 1.5s, display 5s ease-out 0.5s;
  background: ${themes.colors.mainColor};
`;

const AnimationDiv = styled.img`
  width: 100vw;
  height: 100vh;
  position: absolute;
  @keyframes spin {
    from {
      transform: rotate(0deg) scale(0.7);
    }

    to {
      transform: rotate(720deg) scale(0.7);
    }
  }
  animation: spin 20s infinite linear;
`;

const LogoImg = styled.img`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40rem;
  @media ${themes.device.tablet} {
    width: 30rem;
  }
  @media ${themes.device.mobileL} {
    width: 20rem;
  }
`;
export { AnimationDiv, AnimationBlock, LogoImg };
